import type { ReactNode, SelectHTMLAttributes } from "react";
import { ChevronDown } from "lucide-react";
import { formField } from "@web/theme/theme";
import { FormField } from "./FormField";

export type PickerOption = { value: string; label: string; disabled?: boolean };

export type PickerProps = Omit<SelectHTMLAttributes<HTMLSelectElement>, "className" | "id" | "onChange" | "value"> & {
  label: ReactNode;
  options: readonly PickerOption[];
  value: string;
  onChange: (value: string) => void;
  /** First, empty option. */
  placeholder?: string;
  hint?: ReactNode;
  error?: ReactNode;
  className?: string;
};

/** Native `<select>` styled with tokens: the phone gets the OS picker, desktop a dropdown. */
export function Picker({ label, options, value, onChange, placeholder, hint, error, className = "", ...rest }: PickerProps) {
  return (
    <FormField label={label} hint={hint} error={error} className={className}>
      {(a11y) => (
      <div className={formField.selectWrap}>
        <select {...a11y} value={value} onChange={(e) => onChange(e.target.value)} className={`${formField.control} ${formField.select}`} {...rest}>
          {placeholder !== undefined && <option value="">{placeholder}</option>}
          {options.map((o) => (
            <option key={o.value} value={o.value} disabled={o.disabled}>
              {o.label}
            </option>
          ))}
        </select>
        <ChevronDown aria-hidden size={18} className={formField.selectIcon} />
      </div>
      )}
    </FormField>
  );
}
